import svgUrl from "ni:svgr;ACQkCM1RY-nllSU9O-sh7ftv4Y94vDg-VjWjZZulVLc";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const LeftJoinLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><circle cx={21} cy={16} r={11} fill="var(--tbl--colors--icons--transformation--tertiary)" /><circle cx={11} cy={16} r={11} fill="var(--tbl--colors--icons--transformation--primary)" /><path fill="#fff" fillOpacity={0.2} fillRule="evenodd" d="M16 25.8a11 11 0 0 0 6-9.8 11 11 0 0 0-6-9.8 11 11 0 0 0-6 9.8 11 11 0 0 0 6 9.8Z" clipRule="evenodd" /></svg>;
const Memo = memo(LeftJoinLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "LeftJoinLIcon";
}